<template>
    <div v-if="loading||data">
        <v-layout row v-if="data">
            <v-spacer></v-spacer>
            <v-btn class="accent ma-2"  @click="downloadData">
                <v-icon small class="mr-2">fa-download</v-icon>
                {{ title|translate }}
            </v-btn>
        </v-layout>

        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
    </div>
</template>

<script>
import LoadingProgressBar from "../LoadingProgressBar";
import {callAPI} from '@/helper'
import data3Processor from "../mixins/data3Processor";
import {exportNamedCSVFromDicts} from "../../tocsv";

export default {
    props: {
        parameters: {type: Object, default: null},
        equipment: {type:String, default: null},
        title: {type:String, default: "Export Data"},
        fileName: {type:String, default: "CSV Export"},
        includeRangeInName: {type:Boolean, default: false},
        dateRange: {type: Object, default: null},
        data3query: {
            type: Object, default:null
        },
    },
    components: {LoadingProgressBar},
    mixins:[data3Processor],
    computed: {

    },
    name: 'DataExportWidget',
    data: function () {
        return {
            data:null,
            loading:false,
            reloadInc:0,
            timeout:null,
        }
    },
    beforeDestroy: function(){
        clearInterval(this.interval)
    },
    watch: {
        dateRange () {
            if (this.data3query) {
                this.refresh()
            }
        },
        equipment () {
            if (this.data3query) {
                this.refresh()
            }
        },
        parameters:{
            handler() {
                if(this.data3query){
                    this.refresh()
                }
            },
            deep: true,
            immediate: true,
        },
    },
    mounted: function(){
        this.refresh()
    },
    methods: {
        downloadData() {
            let name = this.includeRangeInName ? this.fileName+" from "+this.dateRange.start+" to "+this.dateRange.end : this.fileName
            exportNamedCSVFromDicts(this.data,name)
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.getData,500);
        },
        async getData(){
            clearInterval(this.interval)
            this.loading=true
            this.data=null
            let data = {}
            this.reloadInc=this.reloadInc+1
            let currentInc=this.reloadInc
            if (this.data3query) {
                let payloadArray = JSON.parse(JSON.stringify(this.data3query['data-payload']))
                payloadArray = payloadArray.filter(x => x.filters && (x.filters.sensor_name || x.filters.equipment_name))
                for (let payload of payloadArray) {
                    payload.parameters=this.parameters
                    this.processDateRange(payload, this.dateRange)
                    if (!payload.filters.facility_name && this.$store.state.pointsListStore.pointsList.facility_name) {
                        payload.filters.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                    }
                    if(this.equipment){
                        this.processEquipment(payload, this.equipment)
                    }
                    if (payload.onOnly) {
                        if (!payload.pipeline) {
                            payload.pipeline = []
                        }
                        payload.pipeline.unshift(
                            {
                                "type": "filter",
                                "filter_op": "eq",
                                "filter_by": "* - on",
                                "filter_value": 1,
                            }
                        )
                    }
                }
                let promises = payloadArray.map(payload => callAPI('data3/', payload))
                let results = await Promise.all(promises)
                if (currentInc!==this.reloadInc){
                    return
                }
                for (let result of results) {
                    for (let seriesIndex in result.data) {
                        if (!data[seriesIndex]) {
                            data[seriesIndex] = result.data[seriesIndex]
                        }
                    }
                }
                if (Object.keys(data).length<2){
                    this.loading=false
                    return
                }
                this.data=data
            }
            this.loading=false
        }
    }
}

</script>

<style scoped>

</style>
